import React from 'react';
import { CheckCircleIcon, ClockIcon, BrainCircuitIcon, SparklesIcon, ZapIcon, BoxIcon } from 'lucide-react';
const DifferentiatorCard = ({
  icon: Icon,
  title,
  description
}) => {
  return <div className="border border-zinc-200 p-6 rounded-sm gradient-card-light" data-id="element-167">
      <div className="text-teal-dark mb-4" data-id="element-168">
        <Icon size={28} data-id="element-169" />
      </div>
      <h3 className="font-serif text-xl mb-2 text-zinc-900" data-id="element-170">{title}</h3>
      <p className="text-zinc-600" data-id="element-171">{description}</p>
    </div>;
};
export const WhyDifferent = () => {
  return <section id="why-different" className="py-24 bg-zinc-50 text-zinc-800 relative" data-id="element-172">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,rgba(59,166,159,0.1),transparent_70%)]" data-id="element-173"></div>
      <div className="container-custom relative z-10" data-id="element-174">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-175">
          <h2 className="font-serif text-4xl mb-6 text-zinc-900" data-id="element-176">
            How We Are <span className="accent-text" data-id="element-177">Different</span>
          </h2>
          <p className="text-zinc-600" data-id="element-178">
            We offer 'forward deployed AI product owners & engineers'. What we
            provide is currently not widely available in the market.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-179">
          <DifferentiatorCard icon={CheckCircleIcon} title="Experience" description="Our team has been developing AI products for over 10 years for dozens of businesses and been used by over a million people." data-id="element-180" />
          <DifferentiatorCard icon={BoxIcon} title="Tools" description="We already have the tools. Our tools have enabled 10,000+ custom AI chatbots and provide a foundation for rapid development." data-id="element-181" />
          <DifferentiatorCard icon={BrainCircuitIcon} title="Expertise" description="We've helped businesses and entrepreneurs launch dozens of products across various industries." data-id="element-182" />
          <DifferentiatorCard icon={SparklesIcon} title="Substance" description="We build businesses and workers, not toys. Zero fluff. Our solutions deliver real-world value and ROI." data-id="element-183" />
          <DifferentiatorCard icon={ZapIcon} title="Speed" description="We only work with clients who want to move fast or have a captive audience. We're built for rapid deployment." data-id="element-184" />
          <DifferentiatorCard icon={ClockIcon} title="Accessible" description="Comparable 'forward-deployed engineer' services such as OpenAI Consulting costs $10 million minimum." data-id="element-185" />
        </div>
      </div>
    </section>;
};